import React from 'react';
import './landing-container.css';
import Form from "../landing-content/form";

export interface LandingContainerProps {
    children?: React.ReactNode;
    titleText?: string;
    titleStyle?: React.CSSProperties;
}

export const LandingContainer: React.FC<LandingContainerProps> = (props) => {

    return (
        <div id="landing">
            {props.children}
            <Form titleText={props.titleText} titleStyle={props.titleStyle}/>
        </div>
    );
}
